import { render, staticRenderFns } from "./AboutMissionPage.vue?vue&type=template&id=81c78ae4&scoped=true&"
import script from "./AboutMissionPage.vue?vue&type=script&lang=js&"
export * from "./AboutMissionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c78ae4",
  null
  
)

export default component.exports